<template>
  <div class="p_zpxq">
    <p class="zpNav"><span @click="()=>this.$router.push('/')">首页</span> > <span @click="()=>this.$router.back()">展商展品</span> > 展品详情</p>
    <div class="zpxqHeader">
      <div class="zpmz">
        <h2>{{list.proname_cn}}</h2>
        
      </div>
    </div>
    <div class="zpxqContent">
      <div class="contentL">
        <div class="conImg">
          <el-image 
            :lazy="true"
            fit="contain"
            :src="list.img_url?list.img_url:'http://e.cippe.com.cn//public/images/logo_1.png'" 
            :preview-src-list="[list.img_url]">
          </el-image>
        </div>
      </div>
      <div class="contentR">
        <p>
          <span class="p1">展品类型：</span>
          <span class="p2">{{list.class_name_cn}}</span>
        </p>
        <p>
          <span class="p1">展商名称：</span>
          <span class="p2 chaolianjie" @click="()=>{this.$router.push('/exhibitor/details/'+list.fk_oeid+'/'+list.ocid)}">{{list.corpname_cn}}</span>
        </p>
        <p>
          <span class="p1">展品描述：</span>
          <span class="p2">{{list.prodetails_cn}}</span>
        </p>
        <p>
          <span class="p1">地<i style="display:inline-block;width:32px"></i>址：</span>
          <span class="p2">{{list.address_cn}}</span>
        </p>
        <p>
          <span class="p1">电<i style="display:inline-block;width:32px"></i>话：</span>
          <span class="p2">{{list.phone}}</span>
        </p>
        <p>
          <span class="p1">规格型号：</span>
          <span class="p2">{{list.pro_specification_type?list.pro_specification_type:'面议'}}</span>
        </p>
        <p>
          <span class="p1">展品价格：</span>
          <span class="p2">{{list.pro_price?list.pro_price:'面议'}}</span>
        </p>

        <div class="detailBtn">
          <button :class="collect==2?'collectActive':''" @click="isCollect(list.id)"><i class="iconFont icon-shoucang"></i>{{collect==2?"已收藏":"收藏"}}</button>
          <button @click="centerDialogVisible = true"><i class="iconFont icon-liuyan"></i>询盘</button>
          <button :class="meet?'':'collectActive'" @click="isCorpApp(list.ocid)"><i class="iconFont icon-dianhua1"></i>{{meet?"约见":"已约见"}}</button>
        </div>
        <button class="intentionBtn" @click="reqIntentiondata">意向订单</button>
      </div>
    </div>
    <div class="exchange">
      <div class="exchangeItem">
        <div class="exchangeTop">
          <span>在线收藏夹</span>
          <img v-lazy="hrefurl+'/public/icon/enshrine.png'" alt=""/>
        </div>
        <div class="exchangeBtn">
          <button :class="collect==2?'btnACtive':''" @click="isCollect(list.id)" @mouseover="inquiry1=true" @mouseout="inquiry1=false">
            <img v-lazy="collect==2||inquiry1?hrefurl+'/public/icon/like_1.png':hrefurl+'/public/icon/enshrine_2.png'" alt=""/>
            {{collect==2?"已&nbsp;收&nbsp;藏":"收&nbsp;藏"}}
          </button>
        </div>
      </div>
      <div class="exchangeItem">
        <div class="exchangeTop">
          <span>立即沟通</span>
          <img v-lazy="hrefurl+'/public/icon/negotiate.png'" alt=""/>
        </div>
        <div class="exchangeBtn1">
          <button @click="centerDialogVisible = true" @mouseover="inquiry=false" @mouseout="inquiry=false">
            <img v-lazy="inquiry?hrefurl+'/public/icon/negotiate_2.png':hrefurl+'/public/icon/negotiate_1.png'" alt=""/>
            询&nbsp;盘
          </button>
        </div>
      </div>
      <div class="exchangeItem">
        <div class="exchangeTop">
          <span>约见洽谈</span>
          <img v-lazy="hrefurl+'/public/icon/pack.png'" alt=""/>
        </div>
        <div class="exchangeBtn">
          <button  :class="meet?'':'btnACtive'" @click="isCorpApp(list.ocid)" @mouseover="inquiry2=true" @mouseout="inquiry2=false">
            <img v-lazy="meet==0||inquiry2?hrefurl+'/public/icon/pack_1.png':hrefurl+'/public/icon/pack_2.png'" alt=""/>
            {{meet?"约&nbsp;见":"已&nbsp;约&nbsp;见"}}
          </button>
        </div>
      </div>
    </div>
    <div class="zplb">
      <Product :xgcp="xgcp" @update="xgxx"/>
    </div>
    <div class="zxkf">
      <div class="divimg"></div>
      <p>联系我们</p>
      <!-- <img src="https://e.cippe.com.cn/public/images/onlineCustomerService.gif" alt=""> -->
      <div class="zxkfPopover">
        <!-- <div></div> -->
        如需咨询展商/展品，<br>
        请联系组委会索取资料！<br>
        电话：<span style="color: #008baf;">010-56176968</span>
      </div>
    </div>
    <!-- 询盘弹窗 start -->
    <el-dialog
      title="询盘" :visible.sync="centerDialogVisible" width="660px" :before-close="handleClose" center>
      <div class="textea">
        <el-input type="textarea" class="popUp" show-word-limit  maxlength="200" placeholder="请输入内容" v-model="textarea"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false;textarea=''">取 消</el-button>
        <el-button type="primary" @click="reqAddCon">发 送</el-button>
      </span>
    </el-dialog>
    <!-- 询盘弹窗 end -->
    <!-- 约见弹窗 start -->
    <el-dialog class="yuyue" title="在线预约" :visible.sync="dialogFormVisible" :before-close="resetForm" width="650px" top="3vh">
      <el-form ref="preAboutData" :model="preAboutData" :rules="rules" label-width="100px" size="mini">
        <el-form-item label="预约日期" prop="date">
          <el-date-picker type="date" placeholder="选择日期" v-model="preAboutData.date" :picker-options='pickerOptions' style="width: 100%;"></el-date-picker>
        </el-form-item>
        <el-form-item label="留言" prop="connet">
          <el-input type="textarea" maxlength="20" show-word-limit placeholder="请输入留言" v-model="preAboutData.connet"></el-input>
        </el-form-item>
        <el-form-item size="large" style="text-align: center;margin-left:-100px">
          <el-button type="primary" @click="submitForm('preAboutData')">立即预约</el-button>
          <el-button @click="resetForm">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 约见弹窗 end -->
    <!-- 意向订单 satrt -->
    <el-dialog class="yuyue intention" title="意向订单" :visible.sync="intention" :before-close="intentionResetForm" width="650px" top="3vh">
      <p class="intention_row">
        <span class="span1">公司名称</span>
        <span class="span2">{{user.corpname}}</span>
      </p>
      <p class="intention_row">
        <span class="span1">姓名</span>
        <span class="span2">{{user.name?user.name:user.nickname}}</span>
      </p>
      <p class="intention_row">
        <span class="span1">手机</span>
        <span class="span2">{{user.mobile}}</span>
      </p>
      <p class="intention_row">
        <span class="span1">邮箱</span>
        <span class="span2">{{user.email}}</span>
      </p>
      <p class="intention_row">
        <span class="span1">展品名称</span>
        <span class="span2">{{list.corpname_cn}}</span>
      </p>
      <p class="intention_row">
        <span class="span1">规格型号</span>
        <span class="span2">{{list.pro_specification_type?list.pro_specification_type:'面议'}}</span>
      </p>
      <p class="intention_row">
        <span class="span1">价格</span>
        <span class="span2">{{list.pro_price?list.pro_price:'面议'}}</span>
      </p>
      <el-form ref="intentionData" :model="intentionData" :rules="intentionRules" label-width="100px" size="mini">
        <el-form-item label="数量" prop="amount">
          <el-input v-model.number="intentionData.amount"></el-input>
        </el-form-item>
        <el-form-item label="收货地点" prop="address">
          <el-input show-word-limit placeholder="请输入收货地点" v-model="intentionData.address"></el-input>
        </el-form-item>
        <el-form-item size="large" style="text-align: center;margin-left:-100px">
          <el-button type="primary" @click="intentionSubmitForm('intentionData')">确认提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 意向订单 end -->
  </div>
</template>

<script>
import { mapState } from "vuex";
import Product from "../../zsxq/pc/product";
import {reqDetails, reqExhibitList, reqProColl, reqProCollDo, reqCorpApp, reqCorpAppDo, reqAddNote, reqListjsonOrderAdd} from "../../../api"
export default {
  components:{
    Product,
  },
  data(){
    var checkNumber = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('数量不能为空'));
      }
      setTimeout(() => {
        if (!Number.isInteger(value)) {
          callback(new Error('请输入数字值'));
        } else {
          if (value < 1) {
            callback(new Error('数量必须大于1'));
          } else {
            callback();
          }
        }
      }, 1000);
    };
    return{
      imgList:["https://picsum.photos/id/334/300/300","https://picsum.photos/id/338/300/300","https://picsum.photos/id/336/300/300","https://picsum.photos/id/334/300/300","https://picsum.photos/id/338/300/300","https://picsum.photos/id/336/300/300","https://picsum.photos/id/334/300/300","https://picsum.photos/id/338/300/300","https://picsum.photos/id/336/300/300"],
      activeImg:"",
      id:0,//展品id
      ocid:0,
      num:0,
      centerDialogVisible:false,
      textarea:"",//询盘内容
      list:{},//展品信息
      xgcp:{},//相关产品
      collect:1,//收藏状态  1未收藏 2已收藏
      meet:1,//邀约状态
      inquiry:false,//询盘
      inquiry1:false,//收藏
      inquiry2:false,//约见
      dialogFormVisible:false,//预约弹窗
      intention:false,//意向订单弹窗
      rules:{//约见校验
        date:[{ type: 'date', required: true, message: '请选择日期', trigger: 'change' }],
        connet:[{required: true, message: '请输入留言', trigger: 'blur'}],
      },
      intentionRules:{//意向校验
        amount:[{ validator: checkNumber, trigger: 'blur' }],
        address:[{required: true, message: '请输入地点', trigger: 'blur'}],
      },
      preAboutData:{//约见数据
        id:0,
        date:"",
        connet:"",
      },
      intentionData:{//意向数据
        id:0,
        amount:1,
        address:'',
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;//如果没有后面的-8.64e7就是不可以选择今天的
        }
      }
      
      
    }
  },
  mounted(){
    this.activeImg=this.imgList[0]
    // 截取字符串
    let id = this.$route.path.split('/')
    this.id=id[id.length-2]*1
    this.ocid=id[id.length-1]*1
    this.reqDetail(this.id)
    this.initCollect(this.id)
    this.initCorpApp(this.ocid)
    if (!this.isLogin) {
      this.$router.push('/home')
    }
  },
  methods:{
    submitForm(formName) {//发送预约表单
      this.$refs[formName].validate(async(valid) => {
        if (valid) {//发送
          this.preAboutData.id=this.list.ocid
          const response = await reqCorpAppDo(this.preAboutData)
          if (response.code==0) {
            this.meet=response.is_coll
            this.success(this,'预约成功！')
            this.dialogFormVisible=false
          }else{
            this.err(this,'预约失败，请稍后重试...')
          }
        } else {//错误
          return false;
        }
      });
    },

    resetForm() {//预约表单重置
      this.$refs.preAboutData.resetFields();
      this.dialogFormVisible=false
      
    },

    async reqIntentiondata(){
      // const response = await reqIntention()
      this.intention=true
    },
    intentionSubmitForm(formName) {//发送意向订单
      this.$refs[formName].validate(async(valid) => {
        if (valid) {//发送
          this.intentionData.id=this.list.id
          const response = await reqListjsonOrderAdd(this.intentionData)
          if (response.code==2) {
            this.success(this,'提交成功！')
            this.intentionResetForm()
          }else{
            this.err(this,'提交失败，请稍后重试...')
          }
        } else {//错误
          return false;
        }
      });
    },

    intentionResetForm(){//意向表单重置
      this.$refs.intentionData.resetFields();
      this.intention=false
    },

    handleClose(){//询盘重置
      this.textarea=""
      this.centerDialogVisible=false
    },
    
    async reqAddCon(){// 询盘上传请求
      if (!this.textarea.length) return
      const response = await reqAddNote(this.list.id,this.textarea)
      if(response.code==0){
        this.err(this,'参展商未在线，请稍后重试')
      }else if (response.code==1) {
        this.centerDialogVisible=false
        this.textarea = ''
        this.success(this,'发送成功')
      }
    },
     
    async reqDetail(id){// 请求列表
      const response = await reqDetails(id)
      if(response.code==0){
          this.list=response.resilt[0]
          this.reqRelatedExh(response.resilt[0].fk_parentid)
      }else{
        this.$router.push("/")
      }
      
    },
    
    async reqRelatedExh(id){// 相关产品请求
      const response = await reqExhibitList(1,id)
      if(response.code==0){
        this.xgcp={list:response.resilt,name:"相关产品"}
      }
    },
    
    async initCollect(id){// 初始获取收藏状态
      const response = await reqProColl(id)
      if (response.code==0) this.collect=response.is_coll
      else this.collect = 1
    },

    async isCollect(id){// 修改收藏状态
      const response = await reqProCollDo(id)
      if (response.code==0) this.collect=response.is_coll
      else this.err(this,"修改失败，请稍后重试。。。")
    },
    
    xgxx(item){// 子组件调用替换产品数据
      this.reqDetail(item.id)
      this.initCollect(item.id)
      this.initCorpApp(item.ocid)
    },
    
    async initCorpApp(ocid){// 初始化约见状态++++
      const response = await reqCorpApp(ocid)
      if (response.code==0) this.meet=response.is_coll
    },
    
    async isCorpApp(){// 修改约见状态
      if (!this.meet) {
        return
      }
      this.dialogFormVisible = true

      // const response = await reqCorpAppDo(ocid)
      // if (response.code==0) this.meet=response.is_coll
    },

  },
  computed:{
    ...mapState({
      isLogin:state=>state.user.isLogin,
      user:state=>state.user.user,
    })
  }

}
</script>

<style scoped>
.p_zpxq{
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  padding-bottom: 30px;
  /* background-color: white; */
  
}
.zpNav{
  position: absolute;
  left: 10px;
  top: 10px;
  font-size: 14px;
  font-weight: 600;
}
.zpNav span{
  cursor: pointer;
}
.zpNav span:hover{
  color: #008baf;
}
.zpxqHeader{
  background-image: url("https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/exhibit/zpxqbg.png");
  width: 100%;
  /* height: 180px; */
  height: 120px;
  padding-top: 60px;
  box-sizing: border-box;
  background-size: 100% 100%;
}
.zsxqHeader::after{
  content: "";
  display: block;
  clear: both;
}
.zpxqImg{
  width: 20px;
}
.zpmz h2{
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 16px;
  padding-left: 10px;
}

.zpxqContent{
  width: 100%;
  padding: 40px 20px;
}
.zpxqContent::after{
  content: "";
  clear: both;
  display: block;
}
.contentL{
  float: left;
  display: flex;
  margin-right: 20px;
  /* width: 34%; */
}
.conLeft{
  width: 80px;
  height: 100%;
  max-height: 300px;
  overflow: hidden;
  /* overflow-y: auto; */
  position: relative;
  margin-right: 10px;
}

.conTop{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  cursor: pointer;
  z-index: 99;
}
.conBottom{
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  cursor: pointer;
  z-index: 99;
}
.conLeft>ul>li{
  cursor: pointer;
  margin-top: 10px;
}
.conLeft>ul>li:nth-child(1){
  margin-top: 20px;
}
.conLeft>ul>li>img{
  width: 100%;
  object-fit: cover;
}
.conImg{
  width: 300px;
  height: 300px;
}
.conImg>>>.el-image{
  width: 100%;
  height: 100%;
}
.conImg>>>.el-icon-circle-close{
  color: white;
}
.conImg>>>.el-image-viewer__canvas{
  padding: 20px;
}
.conImg img{
  /* object-fit: cover; */
}
.contentR{
  /* display: table; */
  height: auto;
  padding-left: 320px;
}
.contentR >p{
  display: table-row;
  width: 100%;
}
.contentR .p1{
  width: 92px;
  display: table-cell;
  font-size: 14px;
  font-weight: 600;
  color: #008baf;
  line-height: 28px;
}
.contentR .p2{
  display: table-cell;
  /* text-indent: 2em; */
  line-height: 24px;
  font-size: 14px;
  width: calc(100% - 92px);
}
.contentR .chaolianjie{
  cursor: pointer;
}
.contentR .chaolianjie:hover{
  color: #008baf;
}
.detailBtn{
  margin-top: 20px;
  text-align: center;
  user-select: none;
  display: none;
}
/* .detailBtn button{
  padding: 8px 26px;
  background-color: #008baf;
  border: none;
  margin-left: 20px;
  border-radius: 4px;
  outline: none;
  color: white;
  transition: all .5s;
  cursor: pointer;
  letter-spacing: 6px;
}
.detailBtn .collectActive,
.detailBtn button:hover{
  background-color: #ff840b;
} */

.intentionBtn{
  width: 100%;
  height: 50px;
  outline: none;
  border: none;
  background-color: #008baf;
  color: white;
  font-size: 18px;
  cursor: pointer;
  margin-top: 30px;
  letter-spacing: .2em;
  transition: all .5s;
}
.intentionBtn:hover{
  background-color: #f08300;
}

.zplb{
  background-color: #eee;
}
.el-dialog__title{
  color: #333;
  font-size: 22px;
}
.textea{
  position: relative;
}
.p_zpxq >>> .el-textarea__inner{
  width: 100%;
  border:1px solid #008baf;
  padding: 10px;
  border-radius: 4px;
  font-size: 14px;
  height: 140px;
}
.dialog-footer>>>.el-button{
  width: 150px;
  height: 40px;
  /* background-color: #008baf;
  border-color: #008baf;
  color: white; */
}
/* .dialog-footer>>>.el-button:hover{
  background-color: #67c3d3;
  border-color: #67c3d3;
} */

 /* 操作 start */
  .exchange{
    margin-bottom: 40px;
    width: 100%;
  }
  .exchange img{
    width: 20px;
  }
  .exchangeItem{
    width: calc(33.33% - 14px);
    padding: 10px 30px;
    background-color: #f7f7f7;
    display: inline-block;
    margin-left: 21px;
  }
  .exchangeItem:first-child{
    margin-left: 0px;
  }
  .exchangeTop{
    font-size: 22px;
    font-weight: 600;
    color: #000;
    padding-bottom: 20px;
  }
  .exchangeTop img{
    float: right;
    width: 80px;
  }
  .exchangeTop::after{
    content: "";
    display: block;
    clear: both;
  }
  .exchangeBtn{
    width: 100%;
  }
  .exchangeBtn>button{
    width: 100%;
    line-height: 40px;
    font-size: 18px;
    font-weight: 600;
    color: #008baf;
    border: 2px solid #008baf;
    background-color: white;
    outline: none;
    cursor: pointer;
    transition: all .5s;
  }
  .exchangeBtn1>button{
    width: 100%;
    line-height: 40px;
    font-size: 18px;
    font-weight: 600;
    color: white;
    border: 2px solid #008baf;
    background-color: #008baf;
    outline: none;
    cursor: pointer;
    transition: all .5s;
  }
  .exchangeBtn>.btnACtive,
  .exchangeBtn>button:hover{
    color: white;
    background-color: #008baf;
  }
  .exchangeBtn1>.btnACtive,
  .exchangeBtn1>button:hover{
    color: white;
    background-color: #055d74;
    border-color: #055d74;
  }
  /* 操作 end */

  /* zxkf */
  .zxkf{
    position: fixed;
    right: 0;
    top: 30%;
    width: 80px;
    height: 84px;
    color: #008baf;
    border-radius: 10px;
    box-shadow: 0 0 4px #ccc;
    transition: all .5s;
  }
  .zxkf .divimg{
    height: 64px;
    background: url(https://e.cippe.com.cn/public/images/service-blue.png) no-repeat;
    background-position: center;
  }
  .zxkf > p{
    text-align: center;
    font-size: 12px;
  }
  .zxkfPopover{
    opacity: 0;
    position: absolute;
    top: 0%;
    right: 80px;
    color: #000;
    width: 190px;
    height: 84px;
    padding: 10px;
    font-size: 14px;
    font-weight: bold;
    box-shadow: 0 0 4px #ccc;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    background-color: #fff;
    transition: all .5s;
  }
  .zxkf:hover{
    background-color: #008baf;
    color: #fff;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .zxkf:hover .divimg{
    background: url(https://e.cippe.com.cn/public/images/service-white.png) no-repeat;
    background-position-x: center;
    color: #fff;
  }
  .zxkf:hover .zxkfPopover{
    opacity: 1;
  }
</style>
<style scoped>
/* 预约弹窗 */
.yuyue>>> .el-dialog{
  background-color: white;
}
.yuyue >>> .el-dialog__body{
  padding: 20px 80px 20px 60px;
}
.yuyue >>>.el-form-item--mini.el-form-item,
.yuyue >>>.el-form-item--small.el-form-item{
  margin-bottom: 24px;
}
.yuyue >>>.el-form-item__label{
  line-height: 40px;
}
.yuyue >>>.el-input .el-input__inner{
  line-height: 40px;
  height: 40px;
}
.yuyue>>>.el-col-2{
  text-align: center;
  line-height: 40px;
}
.yuyue >>> .el-textarea__inner{
  border: 1px solid #dcdfe6;
}
/* .yuyue >>> .el-textarea__inner:focus,
.yuyue >>>.el-input__inner:focus{
  border-color: #008baf;
} */
/* .yuyue>>>.el-button{
  background-color: #008baf;
  border-color: #008baf;
  color: white;
}
.yuyue>>>.el-button:hover{
  border-color: #67c3d3;
  background-color: #67c3d3;
} */

</style>
<style scoped>
  /* 意向订单 */
  .intention_row{
    padding-left: 100px;
    font-size: 14px;
    line-height: 40px;
  }
  .intention_row .span1{
    margin-left: -100px;
    text-align: end;
    display: inline-block;
    width: 100px;
    padding-right: 12px;
  }
  .intention_row .span2{
    padding-left: 12px;
  }
  .intention >>>.el-button{
    width: 100%;
    background-color: #008baf;
    border-color: #008baf;
  }
  .intention >>>.el-button:hover{
    background-color: #67c3d3;
    border-color: #67c3d3;
  }

  
</style>